import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'bilancio-ente-riga';
export const ENTITY_PLURAL = 'Righe Bilancio Ente';

export const gridColumns: EntityListField[] = [
  // {
  //   elementLabel: 'Ord',
  //   filterType: FilterType.number,
  //   fieldType: FieldType.integer,
  //   field: 'ordinamento',
  //   sortable: false,
  //   minWidth: 110,
  //   maxWidth: 110,
  // },
  {
    elementLabel: 'Lettera',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'lettera',
    sortable: false,
    minWidth: 80,
    maxWidth: 80,
  },
  {
    elementLabel: 'Rif. 1',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'rif1',
    sortable: false,
    minWidth: 80,
    maxWidth: 80,
  },
  {
    elementLabel: 'Rif. 2',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'rif2',
    sortable: false,
    minWidth: 80,
    maxWidth: 80,
  },
  {
    elementLabel: 'Rif. 3',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'rif3',
    sortable: false,
    minWidth: 80,
    maxWidth: 80,
  },
  {
    elementLabel: 'Rif. 4',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'rif4',
    sortable: false,
    minWidth: 80,
    maxWidth: 80,
  },
  {
    elementLabel: 'Descrizione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'descrizione',
    sortable: false,
    minWidth: 200,
  },
  {
    elementLabel: 'Importo',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'importo',
    sortable: false,
    minWidth: 160,
    maxWidth: 220,
    contentAlignment: ContentAlignmentEnum.Right,
  },
  {
    elementLabel: 'Importo Anno Prec.',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'importoAnnoPrecedente',
    sortable: false,
    minWidth: 160,
    maxWidth: 220,
    contentAlignment: ContentAlignmentEnum.Right,
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
